/**
*   Bootstrap Add-on's or Fixes
*/

// Add Ons
(function () {

    $('body').on('click', '.btn-toggle', function () {
        var $me = $(this);
        $me.find('.btn').toggleClass('active');

        if ($me.find('.btn-primary').size() > 0) {
            $me.find('.btn').toggleClass('btn-primary btn-default');
            var check = $me.find("input[type=radio]").each(function () {
                $(this)
                    .toggleClass("vjs-input")
                    .prop("checked", !$(this).prop("checked"));
            });
        }
        if ($me.find('.btn-success').size() > 0) {
            $me.find('.btn').toggleClass('btn-success btn-default');
            var check = $me.find("input[type=radio]").each(function () {
                $(this)
                    .toggleClass("vjs-input")
                    .prop("checked", !$(this).prop("checked"));
            });
        }
        /*
        if ($(this).find('.btn-danger').size() > 0) {
        $(this).find('.btn').toggleClass('btn-danger');
        }
        if ($(this).find('.btn-success').size() > 0) {
        $(this).find('.btn').toggleClass('btn-success');
        }
        if ($(this).find('.btn-info').size() > 0) {
        $(this).find('.btn').toggleClass('btn-info');
        } */

    });

} ());
